var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLink } from '../hooks/use-link';
var cls = classNames('reference-link-number');
export var ReferenceNumberLinkDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    border: 1px solid ", ";\n    color: ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    position: relative;\n    top: -5px;\n    left: 3px;\n    margin-right: 3px;\n    cursor: pointer;\n    vertical-align: baseline;\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    border: 1px solid ", ";\n    color: ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    position: relative;\n    top: -5px;\n    left: 3px;\n    margin-right: 3px;\n    cursor: pointer;\n    vertical-align: baseline;\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  "])), theme.FONT_SIZE(10), theme.COLOR('subtle'), theme.COLOR('subtle'), theme.COLOR('canvas'), theme.UNIT(4), theme.UNIT(4), theme.COLOR('strong'), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  NAME: 'ReferenceNumberLink',
  Container: styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var ReferenceNumberLink = function (props) {
  var componentProps = useComponentProps(My.NAME, ReferenceNumberLinkDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    href = componentProps.href,
    title = componentProps.title;
  var Link = useLink().Link;
  return React.createElement(Link, {
    title: title || '',
    href: href
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, children));
};
ReferenceNumberLink.cls = cls;
var templateObject_1, templateObject_2;